declare const fabiosouzaAjax: { ajaxurl: string; nonce: string }

document.addEventListener('DOMContentLoaded', () => {
  const btn  = document.getElementById('galeriaLoadMore') as HTMLButtonElement | null
  const grid = document.getElementById('galeriaGrid')
  const wrap = document.getElementById('galeriaLoadMoreWrap')

  if (!btn || !grid) return

  btn.addEventListener('click', async () => {
    const offset = parseInt(btn.dataset.offset ?? '6', 10)

    btn.disabled = true
    btn.classList.add('is-loading')

    const body = new FormData()
    body.append('action', 'fabiosouza_galeria_more')
    body.append('nonce', fabiosouzaAjax?.nonce ?? '')
    body.append('offset', String(offset))

    try {
      const res  = await fetch(fabiosouzaAjax?.ajaxurl ?? '/wp-admin/admin-ajax.php', {
        method: 'POST',
        body,
      })
      const json = await res.json()

      if (json.success && json.data.html) {
        // Append new items
        grid.insertAdjacentHTML('beforeend', json.data.html)

        // Trigger enter animation on newly added items
        const newItems = grid.querySelectorAll<HTMLElement>('.galeria-item--ajax')
        for (const item of newItems) {
          item.classList.remove('galeria-item--ajax')
          requestAnimationFrame(() => item.classList.add('galeria-item--in'))
        }

        btn.dataset.offset = String(offset + 3)

        if (!json.data.has_more) {
          wrap?.remove()
        } else {
          btn.disabled = false
          btn.classList.remove('is-loading')
        }
      } else {
        wrap?.remove()
      }
    } catch {
      btn.disabled = false
      btn.classList.remove('is-loading')
    }
  })
})
